export default __webpack_public_path__ + "static/media/window.57787d40.png";